<div *ngIf="profileList">
    <div *ngFor="let profile of profileList">
        {{profile.profileName}}
        <span class="rating-icons">
            <ng-container [ngSwitch]="profile.ratingId">
                <ng-container *ngSwitchCase="CandidateScoreRating.Hottest">
                    <img class="icon" src="/assets/images/svg/flame.svg" alt="flame.svg">
                    <img class="icon" src="/assets/images/svg/flame.svg" alt="flame.svg">
                    <img class="icon" src="/assets/images/svg/flame.svg" alt="flame.svg">
                </ng-container>
                <ng-container *ngSwitchCase="CandidateScoreRating.Hotter">
                    <img class="icon" src="/assets/images/svg/flame.svg" alt="flame.svg">
                    <img class="icon" src="/assets/images/svg/flame.svg" alt="flame.svg">
                </ng-container>
                <img *ngSwitchCase="CandidateScoreRating.Hot" class="icon"
                    src="/assets/images/svg/flame.svg" alt="flame.svg">
                <img *ngSwitchCase="CandidateScoreRating.Marketing" class="icon"
                    src="/assets/images/svg/snowflake.svg" alt="snowflake.svg">
            </ng-container>
        </span>
    </div>
</div>
